import { ContactDupesDto, ContactType } from '@sr/dto';
import { contactDupesApi } from './api.slice';
import { DupesExcludeLists } from './types';
import { normalizePhone } from 'utils/phone-format-helpers';

export const useDupes = (contactType: ContactType, contactString: string, dupesExcludeList?: DupesExcludeLists) => {
  const phone = contactType === 'phone' ? normalizePhone(contactString) : undefined;
  const [reload] = contactDupesApi.endpoints.getDupes.useLazyQuery();
  const { data, isLoading, error } = contactDupesApi.endpoints.getDupes.useQuery(
    { contactType, contactString: phone ?? contactString },
    { skip: contactType === 'phone' && !phone },
  );

  let dupes: ContactDupesDto | undefined = undefined;

  if (data) {
    if (dupesExcludeList)
      dupes = {
        dupesCompanies: data.dupesCompanies.filter((x) => !dupesExcludeList.company?.includes(x.id)),
        dupesEmployees: data.dupesEmployees.filter((x) => !dupesExcludeList.person?.includes(x.id)),
      };
    else dupes = data;
  }

  return {
    dupes,
    isLoading,
    error,
    reload,
  };
};
